"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_contact__us__or__customer__care__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "2fda1d6a-512c-427c-a0e4-19ffbdae74b0",
    x1: 32.25,
    y1: 87.05,
    x2: 59.07,
    y2: 113.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b89b496a-0929-483e-b539-ff5d5a0d838d",
    x1: 150.68,
    y1: 89.09,
    x2: 179.53,
    y2: 117.94,
    xlinkHref: "#2fda1d6a-512c-427c-a0e4-19ffbdae74b0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "9e65807f-ea0f-44d5-89b2-ad2ad4d92d17",
    x1: 153.67,
    y1: 131.24,
    x2: 163.43,
    y2: 140.99,
    xlinkHref: "#2fda1d6a-512c-427c-a0e4-19ffbdae74b0"
  }), /*#__PURE__*/React.createElement("symbol", {
    id: "d25a0804-6903-4177-8103-b4766ba1dc1b",
    "data-name": "Customer_care_ic_hi",
    viewBox: "0 0 191.5 191.5"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "ca2e9cc6-6a5c-4c3f-9004-e1bdc62c64c6",
    "data-name": "Bounding Box",
    points: "0 191.5 0 0 191.5 0 191.5 191.5 0 191.5",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.13,79.75H47.75a0,0,0,0,1,0,0v64.07a0,0,0,0,1,0,0H37.13a16,16,0,0,1-16-16V95.75A16,16,0,0,1,37.13,79.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3,127.75h0V95.85h0a5.55,5.55,0,0,0-5.55,5.55v20.8A5.55,5.55,0,0,0,21.3,127.75Z",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.75,79.75h4.07a4,4,0,0,1,4,4v56.07a4,4,0,0,1-4,4H47.75a0,0,0,0,1,0,0V79.75A0,0,0,0,1,47.75,79.75Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.13,127.75v.07a16,16,0,0,0,16,16H47.75v-2H37.13a16,16,0,0,1-16-16v1.93Z",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,143.82H143.45V79.75H154a16,16,0,0,1,16,16v32.07A16,16,0,0,1,154,143.82Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,127.75h0V95.85h0a5.55,5.55,0,0,1,5.55,5.55v20.8A5.55,5.55,0,0,1,170,127.75Z",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,143.82h-4.07a4,4,0,0,1-4-4V83.75a4,4,0,0,1,4-4h4.07Z",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.55,143.82h-4.07a4,4,0,0,1-4-4v-2a4,4,0,0,0,4,4h4.07Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.74 125.2 32.05 109.66 39.52 79.77 47.75 79.75 47.74 125.2",
    opacity: 0.2,
    fill: "url(#2fda1d6a-512c-427c-a0e4-19ffbdae74b0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,127.43,153.1,110.89l6-30.26h0a16,16,0,0,1,11,15.76Z",
    opacity: 0.2,
    fill: "url(#b89b496a-0929-483e-b539-ff5d5a0d838d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.64,111.78a4,4,0,0,1-4-4V79.9A56.12,56.12,0,0,0,95.58,23.84,55.31,55.31,0,0,0,55.36,40.78,56.9,56.9,0,0,0,39.53,79.9v27.89a4,4,0,0,1-8,0V79.9A65,65,0,0,1,49.6,35.23a63.24,63.24,0,0,1,46-19.39A64.13,64.13,0,0,1,159.64,79.9v27.89A4,4,0,0,1,155.64,111.78Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.58,15.84a63.24,63.24,0,0,0-46,19.39l-.5.53a4,4,0,0,0,.1,5.56l3,3c1-1.23,2-2.43,3.14-3.57A55.31,55.31,0,0,1,95.58,23.84,56,56,0,0,1,139,44.46l3-3a4,4,0,0,0,.11-5.53A63.87,63.87,0,0,0,95.58,15.84Z",
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.53,77.9v2a56.91,56.91,0,0,1,12.7-35.55l-.88-.88A56.89,56.89,0,0,0,39.53,77.9Z",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.64,77.9a55.76,55.76,0,0,0-11.78-34.32l-.88.88A55.79,55.79,0,0,1,151.64,79.9Z",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.58,21.84A55.11,55.11,0,0,0,51.34,43.46l.88.88c.49-.61,1-1.21,1.51-1.8s1.07-1.19,1.63-1.77A55.24,55.24,0,0,1,95.58,23.84c1,0,2.06,0,3.08.09l1,.08c.69,0,1.37.1,2.05.18l1.15.15c.62.08,1.24.17,1.86.27l1.18.21q.9.17,1.79.36l1.15.27c.6.15,1.2.31,1.8.47l1.07.3c.64.19,1.26.4,1.89.61l.91.31c.76.27,1.51.57,2.26.87l.47.18q1.39.58,2.74,1.24l.07,0q1.28.62,2.52,1.31l.6.35c.65.37,1.29.74,1.92,1.14l.71.46c.59.38,1.17.76,1.74,1.16l.72.51q.85.61,1.67,1.25l.66.52q.85.69,1.68,1.4l.54.47q.93.83,1.82,1.69l.3.29a56.49,56.49,0,0,1,4,4.44l.88-.88A56,56,0,0,0,95.58,21.84Z",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.4,127.43l-1.06,16,.24,0a16.19,16.19,0,0,0,9.88-6.92h0Z",
    opacity: 0.2,
    fill: "url(#9e65807f-ea0f-44d5-89b2-ad2ad4d92d17)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,127.75v.07a16,16,0,0,1-16,16H143.55v-2H154a16,16,0,0,0,16-16v1.93Z",
    opacity: 0.06,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170,125.82v-.07a5.55,5.55,0,0,0,5.55-5.55v2a5.55,5.55,0,0,1-5.55,5.55v-1.93Z",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.75,143.82h4.07a4,4,0,0,0,4-4v-2a4,4,0,0,1-4,4H47.75Z",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3,125.82v-.07a5.55,5.55,0,0,1-5.55-5.55v2a5.55,5.55,0,0,0,5.55,5.55v-1.93Z",
    opacity: 0.12,
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.6,167.76H95.75a4,4,0,1,1,0-8H123.6a28,28,0,0,0,28-28v-1.45a4,4,0,0,1,8,0v1.45A36,36,0,0,1,123.6,167.76Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.72,
    y: 155.78,
    width: 32,
    height: 16,
    rx: 8,
    ry: 8,
    fill: "#e90000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.46,165.76a7.59,7.59,0,0,0,.19-3,8,8,0,0,1-7.93,7h-16a8,8,0,0,1-7.93-7,8,8,0,0,0,7.93,9h16a8,8,0,0,0,6.93-4",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.65,167.76H123.6a36,36,0,0,0,36-36v-1.45s0-.07,0-.11a36,36,0,0,1-36,35.56H111.46",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("title", null, "customer-care-hi-dark"), /*#__PURE__*/React.createElement("g", {
    id: "182b1563-d875-4398-9a81-ad889069e41f",
    "data-name": "Customer_care_ic"
  }, /*#__PURE__*/React.createElement("use", {
    id: "70dd5dfe-e754-4958-998c-5ba1f9e105c6",
    "data-name": "Customer_care_ic_hi",
    width: 191.5,
    height: 191.5,
    transform: "translate(0.25 0.25)",
    xlinkHref: "#d25a0804-6903-4177-8103-b4766ba1dc1b"
  })));
}

var _default = ic_contact__us__or__customer__care__dark;
exports.default = _default;